import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { PlatformService } from 'src/app/modules/platform/services/platform.service';
import { Notifications } from './model/notifications.model';

@Component({
  selector: 'app-public-toolbar',
  templateUrl: './public-toolbar.component.html',
  styleUrls: ['./public-toolbar.component.scss'],
})
export class PublicToolbarComponent implements AfterViewInit {
  @Output() closeMenu: EventEmitter<any> = new EventEmitter<any>();
  authUser: boolean = false;
  openMenu: boolean = false;

  badgeActive: number = 0;
  token = localStorage.getItem('X-Auth-Token') ?? '';

  notifications: Notifications | undefined;

  constructor(
    private router: Router,
    private authService: AuthService,
    private platformService: PlatformService,
    private activatedRoute: ActivatedRoute
  ) {
    const token = this.authService.getToken();
    this.authUser = token ? this.authService.isUserTokenExpired() : false;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.scrollToAnchorFromUrl();
      }
    });
  }

  ngOnInit() {
    if (this.authUser) {
      this.getNotifications();
    }
  }

  getNotifications() {
    this.platformService.getNotifications().subscribe((x) => {
      this.notifications = x;
      this.badgeActive = x.list.filter((x: { viewed: boolean }) => {
        return x.viewed == false;
      }).length;
    });
  }

  goToUrl(notification: any) {
    this.markViewed(notification.id);
    const data = notification.data;
    if (data.url) {
      window.open(data.url, '_blank');
    } else {
      this.router.navigate([data.internalUrl]);
    }
  }

  ngAfterViewInit() {
    this.scrollToAnchorFromUrl();
  }

  closesMenu() {
    this.closeMenu.emit('close');
    this.openMenu = false
  }

  openMenuClick() {
    this.openMenu = !this.openMenu;
  }

  markViewed(notificationId: number) {
    this.platformService.viewedNotification(notificationId).subscribe({
      next: (result) => {
        this.getNotifications();
      },
      error: () => {},
    });
  }

  setViewedAll() {
    this.platformService.viewedAllNotification().subscribe({
      next: (result) => {
        console.log(result);
      },
      error: () => {},
    });
  }

  openWhatsapp() {
    window.open(
      'https://api.whatsapp.com/send?phone=5491168197747&amp;text=Hola',
      '_blank'
    );
  }

  openLogin() {
    this.router.navigate(['/auth/login']);
  }

  openRegister() {
    this.router.navigate(['/auth/register']);
  }

  getUsername() {
    const name = localStorage.getItem('name');
    return name ? name : '';
  }

  getLastname() {
    const lastname = localStorage.getItem('lastname');
    return lastname ? lastname : '';
  }

  setAvatarLetters() {
    return this.getUsername().charAt(0) + this.getLastname().charAt(0);
  }

  scrollToAnchorFromUrl() {
    // Solo ejecutar si estamos en la ruta raíz o landing
    const currentRoute = this.router.url.split('?')[0]; // incluye el fragment
    const basePath = currentRoute.split('#')[0];
    
    // Solo procesar fragments si estamos en la landing
    if (basePath === '/' || basePath === '') {
      const location = this.activatedRoute.snapshot.fragment;
      if (location) {
        const element = document?.querySelector('#' + location);
        if (element instanceof HTMLElement) {
          // Solo hacer scroll, NO navegar de nuevo
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          });
        }
      }
    }
  }

  scrollTo(location: string) {
    // Solo navegar si no estamos en la landing
    const currentRoute = this.router.url.split('#')[0].split('?')[0];
    
    if (currentRoute !== '/' && currentRoute !== '') {
      // Navegar a la landing con el fragmento
      this.router.navigate(['/'], { fragment: location });
    } else {
      // Ya estamos en la landing, solo hacer scroll
      const element = document.getElementById(location);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }
    }
  }

  navigateToProjects() {
    this.router.navigate(['/crowdfunding/projects']);
  }

  logout() {
    this.authService.logout();
  }
}
